import React from 'react';
import BreadcrumbRenderer from '@atlassian/jira-breadcrumbs/src/breadcrumb-renderer/index.tsx';
import ProjectBreadcrumb from '@atlassian/jira-breadcrumbs/src/common-breadcrumbs/project/index.tsx';
import { useProject } from '@atlassian/jira-business-entity-project-hook/src/index.tsx';

export const Breadcrumb = () => {
	const project = useProject();

	return (
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore TS2741: Property 'baseUrl' is missing
		<ProjectBreadcrumb
			projectKey={project.key}
			projectName={project.name}
			projectId={String(project.id)}
			isSimplifiedProject={project.isSimplified}
		>
			<BreadcrumbRenderer />
		</ProjectBreadcrumb>
	);
};
